<!-- <div class="row flex-wrap">
  <div class="col-12 d-flex justify-content-end" *ngIf="buttons_header">
    <div class="content-sections flex-wrap mt-2">
      <button
        class="btn"
        [ngClass]="{'btn-primary': config_mode === 'min-max'}"
        (click)="config_mode = 'min-max'"
      >
        Max-min
      </button>
      <button
        class="btn"
        [ngClass]="{'btn-primary': config_mode === 'automatic'}"
        (click)="config_mode = 'automatic'"
      >
        Solicitud automatica
      </button>
        <button
        class="btn"
        [ngClass]="{'btn-primary': config_mode === 'fuzzy-logic'}"
        (click)="config_mode = config_mode = 'fuzzy-logic'"
      >
        FL
      </button>
    </div>
  </div>
 -->
<!-- Dispositivos de la actualizacion masiva: se acomodan en varias lineas si no caben -->
<div *ngIf="massiveUpdate && selectedItems.length > 0" class="cfg-selected">
  <span *ngFor="let item of selectedItems" class="badge badge-secondary p-1">
    {{ item.name }}
  </span>
</div>

<!-- Margen segun el ancho del componente (ver .cfg-narrow en config_sensor_device.scss) -->
<div class="cfg-body" *ngIf="id || selectedItems.length > 0">
  <app-config-min-max-sensors-device
    *ngIf="config_mode === 'min-max'"
    [id]="id"
    [type]="type"
    [pond_id]="pond_id"
    [massiveUpdate]="massiveUpdate"
    [permissions]="permissions"
    [selectedItems]="selectedItems"
    [viewNotifications]="viewNotifications"
  ></app-config-min-max-sensors-device>

  <app-config-automatic-request-device
    *ngIf="config_mode === 'automatic'"
    [id]="id"
    [type]="type"
    [permissions]="permissions"
  ></app-config-automatic-request-device>

  <app-config-fuzzy-logic
    *ngIf="config_mode === 'fuzzy-logic'"
    [id]="id"
    [type]="type"
  ></app-config-fuzzy-logic>
</div>
